export const APP_CONSTANTS = {
  TITLE: 'РАЗРАБОТКА ВЕБ САЙТОВ',
  SUBTITLE: 'Создаем сайты любой сложности. Современный дизайн, быстрая разработка и фокус на результате.',
  WORDBUTTON: 'Подать заявку',
  PHONE: '+7-(913)300-17-90',
};
